export {
  validateSource,
  validate,
  type ValidationError,
  type ValidationResult,
} from "rpml-validator";

export interface RpmlDoc {
  path: string;
  source: string;
}

export interface BuildHtmlOpts {
  title?: string;
}

function escapeHtml(s: string): string {
  return s.replace(
    /[&<>]/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" })[c]!,
  );
}

/** Assemble a self-contained HTML page from RPML docs and the canvas-viewer
 *  runtime JS string. Pure function with no filesystem I/O — browser-safe.
 *
 *  @param docs      Array of { path, source } RPML documents to embed.
 *  @param galleryJs The canvas-viewer runtime bundle as a string. Fetch it yourself:
 *                   `const js = await fetch('/path/to/gallery.js').then(r => r.text())`
 *  @param opts      Optional { title } for the HTML <title> tag.
 */
export function buildHtml(
  docs: RpmlDoc[],
  galleryJs: string,
  opts: BuildHtmlOpts = {},
): string {
  const title = opts.title ?? "RPML Documentation";
  const data = JSON.stringify(docs)
    .replace(/<\/script/gi, "<\\/script")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");

  return `<!doctype html>
<html lang="zh-CN">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>${escapeHtml(title)}</title>
<style>html,body{margin:0;height:100%}</style>
</head>
<body>
<script>globalThis.__RPML_DOCS__ = ${data};</script>
<script type="module">
${galleryJs}
</script>
</body>
</html>
`;
}
